import { lazy } from 'react';
import { ICONS } from '../navigationIcons';

const SettingsPage = lazy(() => import('src/compass/pages/administration/SettingsPage'));
const EHarvestPage = lazy(() => import('src/compass/pages/administration/EHarvestPage'));
const SharepointPage = lazy(() => import('src/compass/pages/administration/SharepointPage'));
const DocusignPage = lazy(() => import('src/compass/pages/administration/DocusignPage'));
const UserOwnerMappingPage = lazy(
  () => import('src/compass/pages/administration/UserOwnerMappingPage')
);
const ReleaseNotesPage = lazy(() => import('src/compass/pages/administration/ReleaseNotesPage'));
const SceReportsPage = lazy(() => import('src/compass/pages/administration/SceReportsPage'));
const UploadsManagementPage = lazy(() => import('src/compass/pages/administration/UploadsManagementPage'));
const LrpQuotesRedirectorPage = lazy(() => import('src/compass/pages/administration/LrpQuotesRedirectorPage'));

export const AdministrationMenu = [
  {
    menuTitle: 'Administration',
    path: 'administration',
    icon: ICONS.user,
    subMenus: [
      {
        title: 'Settings',
        path: 'settings',
        element: <SettingsPage />,
        permission: 'ADMIN',
      },
      {
        title: 'Docusign',
        path: 'docusign',
        element: <DocusignPage />,
        permission: 'ADMIN_DOCUSIGN',
      },
      {
        title: 'eHarvest',
        path: 'eharvest',
        element: <EHarvestPage />,
        permission: 'ADMIN_EHARVEST',
      },
      {
        title: 'Sharepoint',
        path: 'sharepoint',
        element: <SharepointPage />,
        permission: 'ADMIN',
      },
      {
        title: 'User Owner Mapping',
        path: 'userownermapping',
        element: <UserOwnerMappingPage />,
        permission: 'LEGACY',
      },
      {
        title: 'Release Notes',
        path: 'releasenotes',
        element: <ReleaseNotesPage />,
        permission: 'RELEASE_NOTES',
      },
      {
        title: 'SCE Reports (MRTable)',
        path: 'scereports',
        element: <SceReportsPage />,
        permission: 'ADMIN',
      },
      {
        title: 'Uploads Management',
        path: 'uploadsmanagement',
        element: <UploadsManagementPage />,
        permission: 'UPLD_MGT',
      },
      {
        title: 'Public LRP Quotes',
        path: 'lrp-quotes',
        element: <LrpQuotesRedirectorPage />,
        permission: 'ADMIN',
      },
    ],
  },
];
